import { applyMiddleware, compose, createStore, Middleware } from 'redux'
import persistedStore from './root/root.reducers'
import thunk from 'redux-thunk'
import logger from 'redux-logger'

import { persistStore } from 'redux-persist'

const initialState = {}

const middleware: Middleware[] = [thunk]

if (process.env.NODE_ENV === 'development') {
  middleware.push(logger)
}

export const store = createStore(
  persistedStore,
  initialState,
  compose(applyMiddleware(...middleware))
)

export const persistor = persistStore(store)
